export default instance => (start, end, task) => '';
